module.exports = __webpack_public_path__ + "img/is_on_ride_icon.ba84d7cc.png";